import { Component } from '@angular/core'
import { DefaultRowComponent } from '../default-row/default-row.component'
import { CustomTableService } from '../../service/custom-table.service'
import { ICustomTableColumnButton } from '../../modals/interface/custom-table.interface'

@Component({
    selector: 'app-rebate-claims-history-row',
    templateUrl: './rebate-claims-history-row.component.html',
    styleUrls: ['./rebate-claims-history-row.component.scss'],
    standalone: false
})
export class RebateClaimsHistoryRowComponent extends DefaultRowComponent {
  constructor(private customTableService: CustomTableService) {
    super()
  }

  public showCreditOrDebitNote(btn: ICustomTableColumnButton): boolean {
    if (btn.key == 'downloadCreditNote') {
      const id = this.row[this.uid]
      const data = this.customTableService.dataSource[id]
      return !!data.creditNoteId
    }
    if (btn.key == 'downloadDebitNote') {
      const id = this.row[this.uid]
      const data = this.customTableService.dataSource[id]
      return !!data.debitNoteId
    }
    return true
  }

  public onClick(control: any): void {
    this.customTableService.clicked(control, this.row)
  }
}
